import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import {format} from "date-fns";
import api from "../../utils/api";
import {toast} from "react-toastify";

const WiseBerryAPIEnv = process.env.VITE_API_KEY;

const grant_type = "password";
const client_id = 1;
const client_secret = "vrUohoUGuqykR1bV3TLh77mdLSA9QL2jDzaivwrX";

export const postLogIn = createAsyncThunk(
  "auth/login",
  async (obj, {dispatch}) => {
    let data = {
      ...obj,
      grant_type,
      client_id,
      client_secret,
    };

    try {
      const res = await api.post(`${WiseBerryAPIEnv}login`, data);

      // If login is successful, dispatch getUser
      if (res.data.access_token) {
        dispatch(authSlice.actions.setToken(res.data.access_token));
        dispatch(getUser());
      }

      return res.data;
    } catch (err) {
      toast.error(err.response.data.data);
      throw new Error(err.response.data.data);
    }
  }
);

export const checkMFA = createAsyncThunk(
  "auth/checkMFA",
  async (obj, {dispatch}) => {
    let data = {
      ...obj,
    };
    // debugger
    try {
      const res = await api.post(`${WiseBerryAPIEnv}login/user_mfa`, data);
      return res.data;
    } catch (err) {
      toast.error(err.response.data.data);
      throw new Error(err.response.data.data);
    }
  }
);
export const sendMfa = createAsyncThunk("auth/mfa", async (obj, {dispatch}) => {
  let data = {
    ...obj,
    grant_type,
    client_id,
    client_secret,
  };

  try {
    const res = await api.post(`${WiseBerryAPIEnv}login`, data);

    // If login is successful, dispatch getUser

    return res.data;
  } catch (err) {
    toast.error(err.response.data.data);
    throw new Error(err.response.data.data);
  }
});

export const logout = createAsyncThunk("auth/logout", async (arg, thunkAPI) => {
  try {
    // Perform any cleanup operations before logging out, if needed

    // Return the initial state object
    return "logout";
    // eslint-disable-next-line no-unreachable
  } catch (err) {
    // Handle any errors during the logout process
    throw new Error("Error during logout");
  }
});

export const getUser = createAsyncThunk(
  "auth/user",
  async (_, {rejectWithValue}) => {
    try {
      const res = await api.get(`${WiseBerryAPIEnv}member/details`);
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

export const submitUserOffice = createAsyncThunk(
  "auth/submitUserOffice",
  async ({id, params}, {rejectWithValue, dispatch}) => {
    try {
      const res = await api.post(`${WiseBerryAPIEnv}member/${id}`, params, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (res.data.data) {
        await dispatch(getUser());
      }
      toast.success("Office Changed Successfully");
      return res.data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

const initialState = {
  token: null,
  isAuthenticated: false,
  loginError: null,
  loading: false,
  loadingUser: false,
  sessionUser: {},
  sessionError: null,

  mfa: {},
  mfaLoading: false,
  mfaError: null,

  checkMFAData: null,
  checkMFALoading: false,
  checkMFAError: null,

  submitUserOfficeData: null,
  submitUserOfficeLoading: false,
  submitUserOfficeError: null,
};
const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setToken: (state, action) => {
      state.token = action.payload;
    },
    // Other reducers...
  },
  extraReducers: (builder) => {
    builder
      .addCase(postLogIn.pending, (state) => {
        state.loading = true;
      })
      .addCase(postLogIn.fulfilled, (state, action) => {
        state.token = action.payload.access_token;
        state.loading = false;
        state.isAuthenticated = true;
        state.loginError = null;
      })
      .addCase(postLogIn.rejected, (state, action) => {
        state.token = null;
        state.loading = false;
        state.isAuthenticated = false;
        state.loginError = action.error.message;
      })
      .addCase(getUser.pending, (state) => {
        state.loadingUser = true;
      })
      .addCase(getUser.fulfilled, (state, action) => {
        state.sessionUser = action.payload;
        state.loadingUser = false;
        // state.loadingUser = null;
      })
      .addCase(getUser.rejected, (state, action) => {
        state.loadingUser = false;
        // state.loadingUser = action.payload;
        state.sessionUser = {};
      })

      .addCase(sendMfa.pending, (state) => {
        state.mfaLoading = true;
      })
      .addCase(sendMfa.fulfilled, (state, action) => {
        state.mfa = action.payload;
        state.mfaLoading = false;
        state.mfaError = null;
      })
      .addCase(sendMfa.rejected, (state, action) => {
        state.mfa = null;
        state.mfaLoading = false;
        state.mfaError = action.payload;
      })
      .addCase(checkMFA.pending, (state) => {
        state.checkMFALoading = true;
      })
      .addCase(checkMFA.fulfilled, (state, action) => {
        state.checkMFAData = action.payload;
        state.checkMFALoading = false;
        state.checkMFAError = null;
      })
      .addCase(checkMFA.rejected, (state, action) => {
        state.checkMFAData = null;
        state.checkMFALoading = false;
        state.checkMFAError = action.payload;
      })

      .addCase(submitUserOffice.pending, (state) => {
        state.submitUserOfficeLoading = true;
      })
      .addCase(submitUserOffice.fulfilled, (state, action) => {
        state.submitUserOfficeData = action.payload;
        state.submitUserOfficeLoading = false;
        state.submitUserOfficeError = null;
      })
      .addCase(submitUserOffice.rejected, (state, action) => {
        state.submitUserOfficeData = null;
        state.submitUserOfficeLoading = false;
        state.submitUserOfficeError = action.payload;
      })
      .addCase(logout.fulfilled, (state, action) => {
        // Set the state to the initial state returned by the logout async thunk
        return initialState;
      });
  },
});

// export const {loginSuccess, logoutSuccess, signUpSuccess} = authSlice.actions;
export default authSlice.reducer;
